module.exports = __webpack_public_path__ + "static/img/2.6bb6168.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/2020.3.26/2.jpg
// module id = JQl1
// module chunks = 1